// extracted by mini-css-extract-plugin
module.exports = {"chart":"OrdersChart_chart_GNhZQ"};